module.exports = ".spacediv{\n    margin-top: 4px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/broker/broker-audit-declaration/enter-data-brokerage-info/enter-data-brokerage-info.component.css
// module id = ./src/app/broker/broker-audit-declaration/enter-data-brokerage-info/enter-data-brokerage-info.component.css
// module chunks = main